import { createStorageSlot } from '@gonfalon/browser-storage/createStorageSlot';

const AGENT_CONTROL_VALUE = 'agent-control';

/**
 * When set, successful signup (email or OAuth) redirects to AI Configs welcome
 * instead of the default get-started / SDK setup path.
 */
export const signupPostAuthDestinationSlot = createStorageSlot('signup-post-auth-destination', {
  storageType: 'sessionStorage',
});

export function setAgentControlSignupPostAuthDestination(): void {
  signupPostAuthDestinationSlot.set(AGENT_CONTROL_VALUE);
}

export function clearAgentControlSignupPostAuthDestination(): void {
  signupPostAuthDestinationSlot.remove();
}

export function isAgentControlSignupPostAuthPending(): boolean {
  return signupPostAuthDestinationSlot.get() === AGENT_CONTROL_VALUE;
}

/** @returns true if this signup should land on the AI Configs welcome flow */
export function consumeAgentControlSignupPostAuthDestination(): boolean {
  const v = signupPostAuthDestinationSlot.get();
  if (v === AGENT_CONTROL_VALUE) {
    signupPostAuthDestinationSlot.remove();
    return true;
  }
  return false;
}
